import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteScheduledContentModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteScheduledContentModalContainer" */
      './DeleteScheduledContentModalContainer'
    ),
  loading: LoadingModal,
});
